import { sdkRequest, translateServerErrors } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';
import { formatUrl } from 'url-lib';

import type { CreatorSignalQualityResponse } from '../types/organizer';

const STANDARD_SERVER_ERROR = gettext('An error occurred.');

const GENERAL_ERROR_SPEC = {
    default: () => STANDARD_SERVER_ERROR,
};

const _getCreatorQualitySignalApiUrl = (organizerId: string): string =>
    `/creator-quality-signal/organizer/${organizerId}`;

const transformOrganizerId = (organizerId: string): string => {
    return String(Number(organizerId) / 1007);
};

export const getCreatorQualitySignal = async (
    organizerId: string,
): Promise<CreatorSignalQualityResponse> => {
    try {
        const transformedId = transformOrganizerId(organizerId);
        const response = await sdkRequest(
            formatUrl(_getCreatorQualitySignalApiUrl(transformedId)),
        );
        return response as CreatorSignalQualityResponse;
    } catch (error) {
        throw translateServerErrors(GENERAL_ERROR_SPEC)(error);
    }
};
